import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'quantityAllocated',
     field: FIELDS.QUANTITY_ALLOCATED,
     title: 'Quantity Allocated',
     label: 'Quantity Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantityToPull',
     field: FIELDS.QUANTITY_TO_PULL,
     title: 'Quantity To Pull',
     label: 'Quantity To Pull',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'quantityPulled',
     field: FIELDS.QUANTITY_PULLED,
     title: 'Quantity Pulled',
     label: 'Quantity Pulled',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumberConfirmed',
     field: FIELDS.PART_NUMBER_CONFIRMED,
     title: 'Part Number Confirmed',
     label: 'Part Number Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'manufacturerName',
     field: FIELDS.MANUFACTURER_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'manufacturerConfirmed',
     field: FIELDS.MANUFACTURER_CONFIRMED,
     title: 'Manufacturer Confirmed',
     label: 'Manufacturer Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCodeConfirmed',
     field: FIELDS.DATE_CODE_CONFIRMED,
     title: 'Date Code Confirmed',
     label: 'Date Code Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'LotCode',
     label: 'LotCode',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCodeConfirmed',
     field: FIELDS.LOT_CODE_CONFIRMED,
     title: 'Lot Code Confirmed',
     label: 'Lot Code Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revisionConfirmed',
     field: FIELDS.REVISION_CONFIRMED,
     title: 'Revision Confirmed',
     label: 'Revision Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'conditionConfirmed',
     field: FIELDS.CONDITION_CONFIRMED,
     title: 'Condition Confirmed',
     label: 'Condition Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'cooConfirmed',
     field: FIELDS.COOCONFIRMED,
     title: 'COO Confirmed',
     label: 'COO Confirmed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warehouseId',
     field: FIELDS.WAREHOUSE_ID,
     title: 'WarehouseId',
     label: 'WarehouseId',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: 'WarehouseName',
     label: 'WarehouseName',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
